import Cookies from "js-cookie";
import config from "@/config";

import { forEach, hasOneOf } from '@/libs/tools'

import {Notification} from "element-ui";

import "element-ui/lib/theme-chalk/index.css";

var CryptoJS = require("crypto-js");

export const TOKEN_KEY = "token";

export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, { expires: config.cookieExpires || 1 });
};

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);
  if (token) return token;
  else return false;
};

export const localSave = (key, value) => {
  localStorage.setItem(key, value);
};

export const localRead = key => {
  return localStorage.getItem(key) || "";
};

export const getConfigValueByKey = (config, key, rv) => {
  if (config.filter(x => x.key == key).length == 0) return rv;
  else return config.filter(x => x.key == key)[0].value;
};

export const hasChild = (item) => {
  return item.children && item.children.length !== 0
}

// const showThisMenuEle = (item, access) => {
//   if (item.meta && item.meta.access && item.meta.access.length) {
//     if (hasOneOf(item.meta.access, access)) return true
//     else return true
//     //else return false
//   } else return true
// }

export const findRouteNameByPath = (routes, path) => {
  let findName = '';
  routes.forEach(rt => {
    if(rt.path == path)
      findName = rt;
    else{
      rt.children.forEach(sbrt=>{
        //console.log(sbrt.path)
        if(sbrt.path.indexOf(':ot')>-1)
        {
          sbrt.path = sbrt.path.replace(':ot', sbrt.meta.ot);
        }
        //console.log(sbrt, sbrt.path, path, (sbrt.path==path))
        if(sbrt.path == path)
          findName = sbrt;
      })
    }    
  })
  return findName;
}

export const createRoute = (data, access) => {
  //console.log(data);
  if(hasOneOf(data.meta.access, access))
  {
    let _route = {
      name: data.name,
      path: data.path,
      meta: {
        login: data.meta.login,
        ot: data.meta.ot,
        access: data.meta.access
      },
      component: () => import("@/views/"+data.component),
      children:[]
    };
    if(data.children!=null && data.children.length>0){
      data.children.forEach(subMenu => {
        let sub=createRoute(subMenu, access);
        if(sub!=null)
        {
          _route.children.push(sub)
        }        
      });        
    }
    return _route;
  }
  else 
    return null;
    
}
export const getMenuByRouter = (list, access) => {
  let res = []
  forEach(list, item => {    
    if (item.meta!=undefined || (item.meta!=undefined && !item.meta.hideInMenu)) {
        let obj = {
          icon: (item.meta && item.meta.icon) || '',
          name: item.name,
          meta: item.meta
        }
        //if ((hasChild(item) || (item.meta && item.meta.showAlways)) && showThisMenuEle(item, access)) {
         if (hasChild(item)) {
           obj.children = getMenuByRouter(item.children, access)
           //console.log(obj.children);
         }
    //     if (item.meta && item.meta.href) obj.href = item.meta.href
    //     if (showThisMenuEle(item, access)) res.push(obj)
    res.push(obj)
    }
  })
  return res
}

export const dynamicDispatcher = (res) => {

  var Pass = CryptoJS.enc.Utf8.parse(res.data.substring(0, 22));
  var encryptData = res.data.substring(22, res.data.length);

  try {
    var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
    var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
    var key128Bits1000Iterations = CryptoJS.PBKDF2(
      Pass.toString(CryptoJS.enc.Utf8),
      Salt,
      { keySize: 128 / 32, iterations: 1000 }
    );
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(encryptData)
    });

    var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key128Bits1000Iterations,
      { mode: CryptoJS.mode.CBC, iv: iv, padding: CryptoJS.pad.Pkcs7 }
    );
    //console.log(decrypted.toString(CryptoJS.enc.Utf8));
    //console.log(decrypted);
    let data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    //console.log()
    //console.log("data first !", data);
    if (data.code !== 200) {
      if (data.code === 401) {
        //console.log("401");
        Cookies.remove(TOKEN_KEY)
        window.location.href = '/#/login'
        // window.location.href = '/#/login'
        // Notice.error({desc:'Нэвтрэх шаардлагатай'})
      } else if (data.code === 204) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 6000,          
          type: "error",
          position: 'top-right',
          offset: 50
        });       
      } else if (data.code === 201) {        
       
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 3000,          
          type: "info",
          position: 'top-right',
          offset: 50
        });

      } else if (data.code === 202) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 6000,          
          type: "warning",
          position: 'top-right',
          offset: 50
        });
      } else if (data.code === 203) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 30000,          
          type: "error",
          position: 'top-right',
          offset: 50
        });
      } else if (data.code === 503) {
        Notification.info({
          message: data.msg,
          title: "Мэдэгдэл",
          duration: 30000,          
          type: "error",
          position: 'top-right',
          offset: 50
        });
      }
      //   if (data.msg) Notice.error({
      //     title: 'Алдаа',
      //     desc: data.msg,
      //     duration:20
      // });

      // this.hideLoading();
      return false;
    } else return data;
  } catch (ex) {

    Notification.info({
      message: ex,
      title: "Мэдэгдэл",
      duration: 10000,          
      type: "warning",
      position: 'top-right',
      offset: 50
    });

    //console.log("dynamicDispatcher ecxeption", ex);
    return "";
  }
};
